import React from 'react';
import PropTypes from 'prop-types';
import Veriff from '../components/Veriff';

function VendorContainer({ translate }) {
  return (
    <React.Fragment>
      <Veriff translate={translate} />
    </React.Fragment>
  );
}

VendorContainer.propTypes = {
  translate: PropTypes.func.isRequired
};

export default VendorContainer;
